<template>
  <div v-show="isVisible">
    <alert-window ref="alertWindow"></alert-window>
    <div class="title">Описание услуги:</div>
    <div class="dop-info">
      <div>
        <div class="fieldset">
          <label class="fieldset-title">Время прибытия</label>
          <fieldset>
            <input type="text" class="time" placeholder="hh:mm" v-mask="'##:##'" v-model="time">
          </fieldset>
        </div>
        <div class="fieldset">
          <label class="fieldset-title">Категория</label>
          <fieldset>
            <select v-if="isNew" v-model="newMoverService.category" @change="onCategoryChange">
              <option disabled :value="null">-- Выбрать --</option>
              <option v-for="category in moverCategories" :value="category">
                {{ category.name }}
              </option>
            </select>
            <select v-else v-model="moverService.category" @change="onCategoryChange">
              <option disabled :value="null">-- Выбрать --</option>
              <option v-for="category in moverCategories" :value="category">
                {{ category.name }}
              </option>
            </select>
          </fieldset>
        </div>
        <div class="fieldset">
          <label class="fieldset-title long-title">Клиентское время<br> (прогноз)</label>
          <fieldset :class="[ { 'fieldset-error' : invalidClientTime } ]">
            <input type="text" class="time" v-mask="'##:##'" v-model="clientTime" placeholder="hh:mm" @blur="checkClientTime">
            <span v-if="invalidClientTime" class="error-text">
              Введённое время меньше минимального ( {{this.currentService.category.minDuration}}ч ) для выбранной категории
            </span>
          </fieldset>
        </div>
      </div>
    </div>
    <div class="title">Адреса:</div>
    <div class="address-section">
      <div class="selected-address-form" v-show="moverServiceAddresses.length > 0">
        <div class="fieldset">
          <draggable v-model="moverServiceAddresses">
            <div class="address" v-for="address in moverServiceAddresses">
              <fieldset class="address-fieldset">
                <input type="text" :value="displayAddress(address)" readonly>
              </fieldset>
              <span class="move-button" title="Переместить"><img src="../image/move.svg"></span>
            </div>
          </draggable>
        </div>
      </div>
      <div class="fieldset select-address-button">
        <div class="add-address" @click="showAddressesFromOrder = true"><span
          class="icon">+</span>Выбрать адреса
        </div>
      </div>
      <div class="select-address-form" v-show="showAddressesFromOrder">
        <div class="fieldset">
          <div class="address" v-for="(address, index) in addressesFromOrder">
            <fieldset class="address-fieldset">
              <input type="text" :value="displayAddress(address)" readonly>
            </fieldset>
            <label class="checkbox-label"><input type="checkbox" @change="addOrRemoveAddress(index, $event)"
                                                 v-model="checkboxesForAddressesFromOrder[index]">выбрать</label>
          </div>
        </div>
        <div class="buttons">
          <button type="button" @click="showAddressesFromOrder = false">Готово</button>
        </div>
      </div>
    </div>
    <div class="buttons">
      <button type="button" class="save-button" @click="saveChanges">Сохранить</button>
    </div>
  </div>
</template>
<script>
  import Timepicker from 'vue2-timepicker'
  import draggable from 'vuedraggable'
  import utils from '@/utils'
  import {mask} from 'vue-the-mask'
  import AlertWindow from '@/components/AlertWindow.vue'

  export default {
  name: 'MoverService',
  props: ['isVisible', 'index', 'isNew', 'count', 'addressesFromOrder', 'orderDateTime'],

  components: {
    Timepicker,
    draggable,
    AlertWindow
  },

  directives: { mask },

  data () {
    return {
      newMoverService: {
        type: 'OrderToMover',
        pathToClass: 'ru.itbrick.shustrikoffcrm.beans.OrderToMover',
        category: null,
        clientTime: null,
        predictionTime: null,
        date: 0
      },

      moverService: {
        category: null,
        clientTime: null,
        predictionTime: null,
        date: 0
      },

      moverCategories: [],
      moverServiceAddresses: [],
      showAddressesFromOrder: false,
      checkboxesForAddressesFromOrder: []
    }
  },

  computed: {
    currentService: {
      get () {
        return this.isNew
          ? this.newMoverService
          : this.moverService
      },

      set (service) {
        if (this.isNew) {
          this.newMoverService = service
        } else {
          this.moverService = service
        }
      }
    },

    time: {
      get () {
        return utils.getFormattedTimeStringFromLongWithoutTimezone(this.currentService.date)
      },

      set (value) {
        if (value.length == 5) {
          let date = new Date(this.currentService.date)
          date.setHours(0, 0, 0, 0)
          this.currentService.date = new Date(date.getTime() + utils.getLongFromFormattedTimeString(value)).getTime()
        }
      }
    },

    clientTime: {
      get () {
        return utils.getFormattedTimeStringFromLongWithoutTimezone((new Date()).setHours(0, 0, 0, 0) + (this.currentService.clientTime))
      },

      set (value) {
        if (value.length === 5) { this.currentService.clientTime = utils.getLongFromFormattedTimeString(value) }
      }
    },

    invalidClientTime: {
      get () {
        return this.currentService.category &&
            this.currentService.clientTime < this.currentService.category.minDuration * 3600000
      }
    },

    moverServiceAddressesCoords () {
      return this.moverServiceAddresses.map((address) => utils.getCoordsStringOfAddress(address))
    }
  },

  watch: {
    isVisible (val) {
      if (val) {
        this.moverCategories = this.$store.getters.moverCategories
        if (!this.isNew) {
          this.moverService = Object.assign({}, this.$store.getters.groupedServices[this.index][0])

          this.moverServiceAddresses = []
          if (this.moverService.addresses != null) {
            this.moverServiceAddresses.push.apply(this.moverServiceAddresses, this.moverService.addresses)
          }

          this.checkboxesForAddressesFromOrder = this.fillAddressesFromOrderCheckboxes()
        } else {
          this.newMoverService = {
            type: 'OrderToMover',
            pathToClass: 'ru.itbrick.shustrikoffcrm.beans.OrderToMover',
            category: this.moverCategories[0],
            clientTime: null,
            predictionTime: null,
            date: this.orderDateTime
          }

          this.newMoverService.clientTime = this.newMoverService.category.minDuration * 3600000

          if (this.$store.getters.groupedServices.length > 0) {
            let mainServices = this.$store.getters.groupedServices.filter(gs => gs[0].type != 'OrderToAdditional')

            if (mainServices.length > 0) {
              let previousService = mainServices[mainServices.length - 1][0]

              if (previousService.clientTime) {
                if(previousService.clientTime >= this.newMoverService.clientTime && previousService.clientTime !== 24 * 60 * 60 * 1000) {
                  this.newMoverService.clientTime = previousService.clientTime
                }
              }
              if (previousService.addresses && previousService.addresses.length > 0 && previousService.type != 'OrderToPetrol') {
                this.newMoverService.addresses = previousService.addresses
                  .filter(address => address.lat != null && address.lng != null)
                  .map(address => Object.assign({}, address))
              }
            }

            this.moverServiceAddresses = this.newMoverService.addresses
              ? this.newMoverService.addresses : []
            this.checkboxesForAddressesFromOrder = this.fillAddressesFromOrderCheckboxes()
          }
        }
      }
      this.showAddressesFromOrder = false
    }
  },

  methods: {
    displayAddress (address) {
      if (!address || !address.place)
        return '';
      return utils.getSmallAddressFromFull(address.place)
          + (address.comment ? (' ' + address.comment) : '');
    },

    addOrRemoveAddress (index, e) {
      let tmpAddress = Object.assign({}, this.addressesFromOrder[index]);

      if (e.target.checked) {
        this.moverServiceAddresses.push(tmpAddress)
      } else {
        let addressFormOrderCoords = utils.getCoordsStringOfAddress(tmpAddress)
        let removeAddressIndex = this.moverServiceAddressesCoords.indexOf(addressFormOrderCoords)
        if (removeAddressIndex > -1) {
          this.moverServiceAddresses.splice(removeAddressIndex, 1)
        }
      }
    },

    fillAddressesFromOrderCheckboxes () {
      return this.addressesFromOrder.map(addressFromOrder => {
        return this.serviceAddressesHaveAddressAlready(addressFromOrder)
      })
    },

    serviceAddressesHaveAddressAlready (addressFromOrder) {
      let addressFormOrderCoords = utils.getCoordsStringOfAddress(addressFromOrder)
      return this.moverServiceAddressesCoords.indexOf(addressFormOrderCoords) != -1
    },

    saveChanges () {
      if (this.moverServiceAddresses.length === 0) {
        this.$refs.alertWindow.show('Ошибка', 'В услуге не выбран ни один адрес', false)
        return false
      }
      let promise
      if (this.isNew) {
        promise = this.addNewService()
      } else {
        promise = this.updateService()
      }
      this.$store.commit('addNewGroupedServicesPromise', promise)
      this.clearAddresses()
      this.$emit('close-window', false)
    },

    clearAddresses () {
      this.moverServiceAddresses = []
      this.checkboxesForAddressesFromOrder = []
    },

    updateService () {
      // при коммите в store index из property является undefined
      let index = this.index
      let count = this.count

      let addresses = this.moverServiceAddresses.map((item, i) => {
        item.orderNum = i
        return item
      })

      let serviceData = {
        addresses: addresses,
        category: this.moverService.category,
        date: this.moverService.date,
        clientTime: this.moverService.clientTime,
        predictionTime: this.moverService.predictionTime
      }

      return new Promise(resolve => {
        utils.spotRegionAndDistrictByAddresses(this.moverServiceAddresses, this.$store.getters.regions, this.$store.getters.districts)
          .then(regionDistrictData => {
            Object.assign(serviceData, regionDistrictData)

            this.$store.dispatch('updateGroupedServiceByIndex', {
              index: index,
              count: count,
              serviceData: serviceData
            }).then(() => resolve())
          })
      })
    },

    addNewService () {
      return new Promise(resolve => {
        this.newMoverService.addresses = this.moverServiceAddresses.map((item, i) => {
          item.id = 0
          item.orderNum = i
          return item
        })

        utils.spotRegionAndDistrictByAddresses(this.moverServiceAddresses, this.$store.getters.regions, this.$store.getters.districts)
          .then(regionDistrictData => {
            Object.assign(this.newMoverService, regionDistrictData)

            let groupedService = []
            for (let i = 0; i < this.count; i++) { groupedService.push(Object.assign({}, this.newMoverService)) }

            this.$store.dispatch('addNewGroupedService', groupedService).then(() => resolve())
          })
      })
    },

    onCategoryChange () {
      this.newMoverService.clientTime = this.currentService.category.minDuration * 3600000
    },

    checkClientTime ($event) {
      if ($event.target.value > 23) {
        this.currentService.clientTime = 82800000
      }
    }
  }
}
</script>
